import Colors from '@constants/Colors';
import { ButtonBase, Stack, useMediaQuery } from '@mui/material';
import MuiPopover from '@mui/material/Popover';
import PopupState, { bindHover, bindPopover, bindTrigger } from 'material-ui-popup-state';
import HoverPopover from 'material-ui-popup-state/HoverPopover';
import * as React from 'react';
import Icons from '@components/Icons';
import Text from '@components/Text';

type Props = {
    children: React.ReactNode;
    label?: string;
    buttonStyle?: React.CSSProperties;
    contentStyle?: React.CSSProperties;
    hover?: boolean;
};

export default function Popover(props: Props) {
    const isMobile = useMediaQuery('(max-width:600px)');

    // Use hover only on desktop when hover prop is true, otherwise always use click
    const shouldUseHover = props.hover && !isMobile;
    const Component = shouldUseHover ? HoverPopover : MuiPopover;
    const binder = shouldUseHover ? bindHover : bindTrigger;

    return (
        <PopupState variant="popover" popupId="demo-popup-popover">
            {popupState => (
                <div onClick={e => e.stopPropagation()} style={{ display: 'inline', marginLeft: 8 }}>
                    <ButtonBase style={props.buttonStyle} {...binder(popupState)}>
                        {props.label ?? <Icons name="info" size={20} color={Colors.NEUTRAL_DARK_GRAY} />}
                    </ButtonBase>
                    <Component
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        PaperProps={{
                            style: {
                                boxShadow: '0px 4px 80px 0px rgba(112, 144, 176, 0.14)',
                                borderRadius: 8,
                            },
                        }}
                        {...bindPopover(popupState)}>
                        <Stack sx={{ p: 2, maxWidth: 300, gap: 1 }} style={props.contentStyle}>
                            {props.children}
                            {!shouldUseHover && (
                                <ButtonBase
                                    style={{
                                        marginTop: 16,
                                        marginLeft: 'auto',
                                    }}
                                    onClick={() => popupState.close()}>
                                    <Text primary bold>
                                        Fermer
                                    </Text>
                                </ButtonBase>
                            )}
                        </Stack>
                    </Component>
                </div>
            )}
        </PopupState>
    );
}
